const withSlash = (path: string) => (path.endsWith("/") ? path : `${path}/`);

export const isPathPrefixActive = (pathname: string, sectionPath: string) => withSlash(pathname).startsWith(withSlash(sectionPath));
const withSlash = (path: string) => (path.endsWith("/") ? path : `${path}/`);

export const isPathPrefixActive = (pathname: string, sectionPath: string) => withSlash(pathname).startsWith(withSlash(sectionPath));
